<template>
  <BaseDataList ref="dataList" :items="linkedContacts" :service="fethcLinkedContacts">
    <template #header>
      <LinkedContactListHeader />
    </template>

    <template #default="{ item }">
      <LinkedContactListItem :contact="item" />
    </template>
  </BaseDataList>
</template>

<script>
import { accountLinkedContactsClient } from '@/api/clients';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import LinkedContactListHeader from './LinkedContactListHeader.vue';
import LinkedContactListItem from './LinkedContactListItem.vue';

export default {
  components: {
    LinkedContactListHeader,
    LinkedContactListItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      linkedContacts: [],
    };
  },
  methods: {
    async fethcLinkedContacts() {
      try {
        const response = await accountLinkedContactsClient.list(this.accountId);

        this.linkedContacts = response.data.map(mapKeysToCamelCase);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
